/* eslint-disable react/jsx-fragments */
/** @jsxRuntime classic */
/** @jsx jsx */
import { LogError } from 'business/constants';
import BlockContent from 'components/blocks/block-content';
import NewsBlock from 'components/blocks/news-block';
import Image from 'components/ui-components/image';
import PageLayout from 'components/ui-components/layout/PageLayout';
import SEO from 'components/utility-wrappers/seo';
import { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Box, Grid, Heading, jsx, Text, useThemeUI } from 'theme-ui';

export default function Post(props) {
  const { slug } = useParams();
  const { theme } = useThemeUI();
  const { data, error } = useSWR(
    `{
      'currentpost': *[_type == 'post' && slug.current == '${slug}']{
        _id,
        title,
        slug,
        publishedAt,
        body []{
          ...,
          _type == "employee" => {
            "employee": @->{...}
          },
          _type == "office_reference" => {
            "office": @->{...}
          },
        },
        seo,
        'main_image': main_image{
          asset->{...},
          ...,
        },
      }[0],
      'newsposts':*[_type == 'post' && slug.current != '${slug}' && !(_id in path("drafts.**"))] | order(publishedAt desc) {
        title,
        _id,
        slug,
        publishedAt,
        'image': main_image
      }[0...9],
      'newspage':*[_type == 'newspage' && _id == 'newspage']{
        headline,
        seo,
        slug,
      }[0],
    }`,
    {},
  );

  if (error || !data) {
    if (error) {
      LogError(undefined, undefined, error);
    }
    return null;
  }

  const { currentpost, newspage = {}, newsposts = {} } = data || {};
  const { main_image, publishedAt, title, body, seo = {} } = currentpost || {};

  return (
    <Fragment>
      <SEO title={title} {...seo} />
      <PageLayout id={title || seo.title || 'Post'}>
        <section
          data-scroll-section
          sx={{
            paddingX: [0, `${100 / 12}vw`],
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            width: ['full', null, '100'],
          }}
        >
          {publishedAt && (
            <Text variant="body">{publishedAt.replace(/-/g, '.')}</Text>
          )}
          <Heading as="h1" variant="h1" sx={{ maxWidth: '60ch' }}>
            {title}
          </Heading>
          <Grid
            sx={{
              gridGap: '4.6rem',
              gridTemplateColumns: ['repeat(1,1fr)', 'repeat(2,1fr)'],
              width: '100%',
              position: 'relative',
              marginTop: ['4rem', null],
            }}
          >
            {main_image && <Image image_asset={main_image} />}
            {body && (
              <BlockContent
                blocks={body}
                sx={{
                  ul: {
                    marginBottom: '4rem',

                    li: {
                      fontSize: [3, null, null, 4],
                      marginBottom: '2rem',
                      paddingLeft: '3rem',
                      position: 'relative',

                      '&:before': {
                        content: '""',
                        width: '0.8rem',
                        height: '0.8rem',
                        borderRadius: '99px',
                        position: 'absolute',
                        left: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'text',
                      },
                    },
                  },
                }}
              />
            )}
          </Grid>
        </section>
        {newspage && newsposts && (
          <Box
            data-scroll-section
            sx={{
              background: [
                `linear-gradient(
                  0deg,
                  transparent 0%,
                  ${theme.colors.pink} 5%,
                  ${theme.colors.pink} 95%,
                  transparent 100%
                )`,
                `linear-gradient(
                  0deg,
                  transparent 0%,
                  ${theme.colors.pink} 10%,
                  ${theme.colors.pink} 90%,
                  transparent 100%
                )`,
              ],
              marginTop: '4',
              paddingY: ['10rem', null, '30rem'],
              paddingX: [3, 0],
              marginX: [-3, 0],
            }}
          >
            <NewsBlock
              isScrollSection={false}
              headline={newspage.headline}
              news={newsposts}
              background={theme.colors.pink}
            />
          </Box>
        )}
      </PageLayout>
    </Fragment>
  );
}
